import React from 'react'
import logo from './house_stats_2.png'
import './App.css'

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="w-3/4" alt="logo" />
        <p className="text-2xl">Coming Soon</p>
      </header>
    </div>
  )
}

export default App
